<div *ngIf="contactSearchLookupDialog.show" class = "overlayForPopups">
  <div cdkDrag>
<uitk-dialog uitkId="viewFilteredContactsData" [(showModal)]="contactSearchLookupDialog.show" [closeBtn]="true" [triggerElementId]="triggerEleId">
  <uitk-dialog-header>
    <div cdkDragHandle>
      Contact Search
    </div>
  </uitk-dialog-header>
  <uitk-dialog-content>
    <div class="row">
      <uitk-form-field>
        <input appAutoFocus uitkInput id="contact-search-textbox" class="textbox mx-3" type="text" [(ngModel)]="contactSearchKeyword"
               style="width: 250px;" (ngModelChange)="onChangeContactKey($event)" (keydown.enter)="showContactDetailsBasedOnKeyword()" />
      </uitk-form-field>
      <span class="uitk-icon uitk-icon-search contactSearchIcon" (click)="showContactDetailsBasedOnKeyword()"
            style="width: 30px;"></span>
      <div id="loadingSpinner" class="uitk-l-grid" *ngIf="loading" style="float:left;width: 30px;margin-top:-55px;margin-right: 66%">
        <uitk-loading-indicator uitkId="spinner" spinnerSize="small">
        </uitk-loading-indicator>
      </div>
      <span style="float:left">* To search for phone, format as XXX/XXX-XXXX XXXXX</span>
    </div>
    <div class="row mt-3">
      <div class="uitk-c-table--responsive container">
        <table uitkTable [dataSource]="filteredContactsData" id="contact-search-details-table" class="uitk-c-table"
               aria-describedby="contact-search-details-data">
          <thead class="uitk-c-table__head">
            <tr uitkTableSort #sortContactSearchTable="uitkTableSort" style="text-align: left">
              <th *ngFor="let headerName of tableHeader" scope="col" uitkTableSortColumn [column]="headerName"
                  (sortChange)="onSortChange($event)">
                {{ headerName}}
              </th>
            </tr>
          </thead>
          <tbody id="contact-search-details-data" class="uitk-c-table__body">
            <ng-container *uitkTableRowBody="let data">
              <tr class="uitk-c-table__row">
                <td style="cursor: pointer; color: #027db4"
                    (click)="selectContact(data)">
                  <p class="address" [innerHTML]="data.contactId | highlightSearch: contactSearchKeyword"></p>
                </td>
                <td style="cursor: pointer;" (click)="selectContact(data)">
                  <p class="address" [innerHTML]="generateFullName(data) | highlightSearch: contactSearchKeyword"></p>
                </td>
                <td style="cursor: pointer;" (click)="selectContact(data)">
                  <p class="address" [innerHTML]="data.company | highlightSearch: contactSearchKeyword">
                  </p>
                  <p class="address" [innerHTML]="data.department | highlightSearch: contactSearchKeyword">
                  </p>
                  <p class="address" [innerHTML]="data.street | highlightSearch: contactSearchKeyword">
                  </p>
                  <p class="address" [innerHTML]="generateCityStateZip(data) | highlightSearch: contactSearchKeyword">
                  </p>
                  <p class="address" [innerHTML]="data.country | highlightSearch: contactSearchKeyword">
                  </p>
                </td>
                <td style="cursor: pointer;" (click)="selectContact(data)">
                  <p class="email" [innerHTML]="data.email | highlightSearch: contactSearchKeyword"></p>
                </td>
                <td style="cursor: pointer;" (click)="selectContact(data)">
                  <p class="address" [innerHTML]="data.phone | phoneFormat | highlightSearch: contactSearchKeyword"></p>
                </td>
                <td style="cursor: pointer;" (click)="selectContact(data)">
                  <p class="address" [innerHTML]="generateStatus(data)"></p>
                </td>
              </tr>
            </ng-container>
            <div *ngIf="filteredContactsData.data.length === 0 && isDataFound">No Results found</div>
          </tbody>
        </table>
      </div>
    </div>
  </uitk-dialog-content>
</uitk-dialog>
  </div>
</div>
